export const SANDBOX_AUTHENTICATION_ENVIRONMENT_SET_BASE_SERVER = "SANDBOX_AUTHENTICATION_ENVIRONMENT_SET_BASE_SERVER";
export const SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR_BASE_SERVER = "SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR_BASE_SERVER";

export const SANDBOX_AUTHENTICATION_ENVIRONMENT_SELECT = "SANDBOX_AUTHENTICATION_ENVIRONMENT_SELECT";
export const SANDBOX_AUTHENTICATION_ENVIRONMENT_SUCCESS = "SANDBOX_AUTHENTICATION_ENVIRONMENT_SUCCESS";
export const SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR = "SANDBOX_AUTHENTICATION_ENVIRONMENT_CLEAR";

export const SANDBOX_AUTHENTICATION_SELECT = "SANDBOX_AUTHENTICATION_SELECT";
export const SANDBOX_AUTHENTICATION_SUCCESS = "SANDBOX_AUTHENTICATION_SUCCESS";
export const SANDBOX_AUTHENTICATION_CLEAR = "SANDBOX_AUTHENTICATION_CLEAR";

export const SANDBOX_AUTHENTICATION_LOGGED_IN = "SANDBOX_AUTHENTICATION_LOGGED_IN";
export const SANDBOX_AUTHENTICATION_LOGGED_OUT = "SANDBOX_AUTHENTICATION_LOGGED_OUT";

